/**
 * Calcola l'altezza di .card__info-bottom nella section Media + Product Banner
 * e la imposta come variabile CSS --mp-card-info-bottom-height sul contenitore
 * della section, così puoi riutilizzarla (es. per limitare l'altezza dell'immagine).
 */
(function () {
  function setCardInfoBottomHeight(section) {
    var infoBottoms = section.querySelectorAll('.card__info-bottom');
    if (!infoBottoms.length) return;
    var height = 0;
    for (var i = 0; i < infoBottoms.length; i++) {
      var h = infoBottoms[i].offsetHeight;
      if (h > height) height = h;
    }
    section.style.setProperty('--mp-card-info-bottom-height', height + 'px');
  }

  function run() {
    var sections = document.querySelectorAll('.mp-product-banner');
    sections.forEach(setCardInfoBottomHeight);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  var resizeObserver = typeof ResizeObserver !== 'undefined'
    ? new ResizeObserver(function () { run(); })
    : null;

  document.addEventListener('DOMContentLoaded', function () {
    var sections = document.querySelectorAll('.mp-product-banner');
    if (resizeObserver) {
      sections.forEach(function (s) { resizeObserver.observe(s); });
    } else {
      window.addEventListener('resize', run);
    }
  });
})();
